export default "__VITE_ASSET__CmkGlodF__"